import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import ModalNew from "components/ModalNew";
import Button from "components/Button";

const mainClass = "delete-attachment-modal";

const DeleteAttachmentModal = ({ title, isOpen, onSubmit, onClose }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);

    try {
      await onSubmit();

      setTimeout(() => {
        setLoading(false);
        if (typeof onClose === "function") onClose();
      }, 300);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  return (
    <ModalNew
      title={t("Delete attachment")}
      variant="delete"
      loading={loading}
      hasMobileScrollTop={false}
      isOpen={isOpen}
      isSubmitHidden
      onClose={onClose}
    >
      <div className={mainClass}>
        <p>
          {t("Are you sure you want to delete the attachment")} "
          <strong>{title ?? "undefined"}</strong>"?{" "}
          <u>{t("This action cannot be undone")}</u>.
        </p>
        <div className={`${mainClass}__cta`}>
          <Button disabled={loading} onClick={handleSubmit}>
            {t(loading ? "Deleting..." : "Delete")}
          </Button>
        </div>
      </div>
    </ModalNew>
  );
};

export default DeleteAttachmentModal;
